import { Button, Stack, Typography } from "@mui/material"
import { MoveLeft, Origami } from "lucide-react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
    return (
        <Stack spacing={2} alignItems="center" justifyContent="center" p={2} sx={{ minHeight: 500 }}>
            <Origami size="80" strokeWidth={1} />
            <Typography variant="h2">Página no encontrada</Typography>
            <Button startIcon={<MoveLeft />} component={Link} to="/comercios">Portada</Button>
        </Stack>
    )
}

export default NotFoundPage;
